import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Radio from "@mui/material/Radio";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import AlertDialog from "./AlertDialog.js";
import { SET_CURRENT_TERM_MUTATION } from "../graphQL/term_qry";
import { project_url } from "../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));

export default function SelectCurrentTermDialog({
  closeDialog,
  termsList,
  selectedCurrentTerm
}) {
  
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [selectedRow, setSelectedRow] = useState(selectedCurrentTerm);
  const [termList, setTermList] = useState([]);
  const [alertMsg, setAlertMsg] = useState([]);
  const [selectedVal, setSelectedVal] = useState("Select");
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set time to 00:00:00 to compare only the date part
  console.log(today);
  let clientId = 1;
  if (localStorage.getItem("clientId"))
    clientId = localStorage.getItem("clientId");
  let clientName = "";
  if (localStorage.getItem("clientName"))
    clientName = localStorage.getItem("clientName");
  let tenantId = 1;
  if (localStorage.getItem("tenantId"))
    tenantId = localStorage.getItem("tenantId");
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  }; 
  const [setCurrentTerm] = useMutation(SET_CURRENT_TERM_MUTATION, {
    awaitRefetchQueries: true,
  });
  
  const handleRadioChange = (id) => {
    
    setSelectedRow(id);
  };
  
  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });  
  
  const columns = [
    {
      field: "select",
      headerClassName: "super-app-theme--header",
      headerName: "Select Term",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return (
        <Radio
          checked={rows.row.id === selectedRow}
          onChange={() => handleRadioChange(rows.row.id)}
        />
        );
      },
    },
    
    {
      field: "name",
      headerName: "Term Name",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "startDate",
      headerClassName: "super-app-theme--header",
      headerName: "Start Date",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    
    {
      field: "endDate",
      headerClassName: "super-app-theme--header",
      headerName: "End Date",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    
    {
      field: "status",
      headerClassName: "super-app-theme--header",
      headerName: "Term Status",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
  ];
  
  const rows = termsList
    .filter((trm) => trm.status === "Active" && new Date(trm.endDate) > today)
    .map((trm, index) => ({ 
      index,
      id: trm.id,
      name: trm.name,
      startDate: trm.startDate,
      endDate: trm.endDate,
      status: trm.status,
      current: trm.current,
  }));

    
  
  const handleDone = async () => {
    const { data, error } = await setCurrentTerm({
          variables: {
                termId: parseInt(selectedRow),
              },
            });
    if (error) {
      if (
        error.graphQLErrors[0].message ===
        "Signature has expired"
      )
        navigate(`${project_url}/signin/?next=${pathname}`);
      else {
        console.log("Error", error, data);
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      }
    } else if (data && data.setCurrentTerm) {
      console.log("Success", data);
      //setAlertMsg({
      //  title: "Success",
      //  msg: "Current term is set successfully.",
      //});
      handleClose();
    }
  };
  
  return (
    <div>
      <Dialog disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "700px",
              height: "600px"
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            Set Current Term
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
            <DataGrid
              className={classes.dataGridStyle}
              columns={columns}
              rows={rows}
              showCellRightBorder={true}
              hideFooter={true}
              autoWidth={true}
              getRowId={row => row.id}
              getRowClassName={params => {
                if (params.row.index % 2 === 0) return "even";
                else return "odd";
              }}
              autoHeight={true}
              experimentalFeatures={{ newEditingApi: true }}
            />
            {errorMsg.form && (
              <Box pt={1}>
                <FormHelperText className={classes.errorStyle} error>
                  {errorMsg.form}
                </FormHelperText>
              </Box>
            )}
            {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => setAlertMsg([])}
            />
          )}
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                onClick={handleDone}
            >
                Save Term
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
